import { getDate, getWeekOfMonth } from 'date-fns';

import { capitalize } from 'constants/helper';

import { RECURRENCE_TYPES } from './Context/GoalRecurrenceDetailsProvider';

const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const parseRecurrenceData = ({ startTS, recurrenceType, recurrenceValue }) => {
  let weeklyRecurrenceDetails = {};
  let monthlyRecurrenceDetails = {};
  let recurrenceText = '';

  const startDate = new Date(startTS);
  const dayOfMonth = getDate(startDate);

  const weekNumber = getWeekOfMonth(startDate) - 1;

  const capitalizedValue = capitalize(recurrenceValue);

  const dayOfWeek = WEEKDAYS.indexOf(capitalizedValue);

  switch (recurrenceType) {
    case 'NONE': {
      recurrenceText = 'None';
      break;
    }
    case 'DAY': {
      weeklyRecurrenceDetails = {
        day: dayOfWeek,
      };
      recurrenceText = `Weekly on ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.fortnightly.FORTNIGHTLY_FIRST: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_WEEK',
        dayOfMonth,
        dayOfWeek,
        weekNumber: 0,
      };
      recurrenceText = `Fortnightly on first ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.month.MONTH_FIRST: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_WEEK',
        dayOfMonth,
        dayOfWeek,
        weekNumber: 0,
      };
      recurrenceText = `Monthly on first ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.fortnightly.FORTNIGHTLY_SECOND: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_WEEK',
        dayOfMonth,
        dayOfWeek,
        weekNumber: 1,
      };
      recurrenceText = `Fortnightly on second ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.month.MONTH_SECOND: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_WEEK',
        dayOfMonth,
        dayOfWeek,
        weekNumber: 1,
      };
      recurrenceText = `Monthly on second ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.fortnightly.FORTNIGHTLY_THIRD: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_WEEK',
        dayOfMonth,
        dayOfWeek,
        weekNumber: 2,
      };
      recurrenceText = `Fortnightly on third ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.month.MONTH_THIRD: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_WEEK',
        dayOfMonth,
        dayOfWeek,
        weekNumber: 2,
      };
      recurrenceText = `Monthly on third ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.fortnightly.FORTNIGHTLY_FOURTH: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_WEEK',
        dayOfMonth,
        dayOfWeek,
        weekNumber: 3,
      };
      recurrenceText = `Fortnightly on fourth ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.month.MONTH_FOURTH: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_WEEK',
        dayOfMonth,
        dayOfWeek,
        weekNumber: 3,
      };
      recurrenceText = `Monthly on Fourth ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.fortnightly.FORTNIGHTLY_LAST: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_WEEK',
        dayOfMonth,
        dayOfWeek,
        weekNumber: 4,
      };
      recurrenceText = `Fortnightly on last ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.month.MONTH_LAST: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_WEEK',
        dayOfMonth,
        dayOfWeek,
        weekNumber: 4,
      };
      recurrenceText = `Monthly on last ${WEEKDAYS[dayOfWeek]}`;
      break;
    }
    case RECURRENCE_TYPES.fortnightly.FORTNIGHTLY_DAY: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_MONTH',
        dayOfMonth,
        dayOfWeek,
        weekNumber,
      };
      recurrenceText = `Fortnightly on ${dayOfMonth}`;
      break;
    }
    case RECURRENCE_TYPES.month.DAY_OF_MONTH: {
      monthlyRecurrenceDetails = {
        recurrenceType: 'DAY_OF_MONTH',
        dayOfMonth,
        dayOfWeek,
        weekNumber,
      };
      recurrenceText = `Monthly on ${dayOfMonth}`;
      break;
    }
    default: {
      recurrenceText = 'Recurrence details';
    }
  }

  return { weeklyRecurrenceDetails, monthlyRecurrenceDetails, recurrenceText };
};
